<template>
  <div id="customer" class="col-sm-4 col-md-4 col-md-offset-4 col-sm-offset-4">
    <h2 class="sub-header">Add Customer</h2>
      <div class="form-group">
        <label>Email address</label>
        <input type="email" class="form-control" v-model="customer.email" placeholder="Email">
      </div>
      <div class="form-group">
        <label>Username</label>
        <input type="text" class="form-control" v-model="customer.username" placeholder="Username">
      </div>
      <div class="form-group">
        <label>Name</label>
        <input type="text" class="form-control" v-model="customer.name" placeholder="Name">
      </div>
      <button @click="addCustomer(customer)" class="btn btn-default">Submit</button>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'AddCustomer',
  data () {
    return {
      customer: {}
    }
  },
  methods: mapActions([
    'addCustomer'
  ])
}
</script>



// WEBPACK FOOTER //
// AddCustomer.vue?09ebcaeb